//主题
export default {
    namespaced: true,
    state: {
        colors:[
            {
                name:'海之蓝',
                color:'#5e90b8'
            },
            {
                name:'粉凤仙',
                color:'#EAC0CE'
            },
            {
                name:'凤仙紫',
                //这个颜色也很好看#D294D3
                color:'#8B658B'
            },
            {
                name:'迷雾灰',
                color:'#545c64'
            }
        ],
        //当前主题颜色
        currentThemeColor:{
            name:'海之蓝',
            color:'#3C5E91'
        }
  },
  getters: {
    //返回主题色的名字数组
    getColorNames(state){
        return state.colors.map(r=>r.name)
    }
  },
  mutations: {
    //更新当前主题色的方法
    updateCurrentThemeColor(state,val){
        state.currentThemeColor = val
    }
  },
  actions: {
    //更新当前主题色的方法
    updateCurrentThemeColor(store,val){
        store.commit('updateCurrentThemeColor', val)
    }
  },
  modules: {
  }
}